import React, { useEffect, useReducer, useState } from 'react';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import { constants } from '../misc/constants';
import BeginScenarioUI from './ui/BeginScenarioUI';
import SplashScreenUI from './ui/SplashScreenUI';
import BadgingProgressUI from './ui/BadgingProgressUI';
import FailUI from './ui/FailUI';
import ModalPopUI from './ui/ModalPopUI';
import RememberUI from './ui/RememberUI';
import HeaderUI from './ui/HeaderUI';
import FooterUI from './ui/FooterUI';
import PatientRecordUI from './ui/PatientRecordUI';
import ResumeUI from './ui/ResumeUI';
import ReturnToMainMenuUI from './ui/ReturnToMainMenuUI';
import FeedbackUI from './ui/FeedbackUI';
import './UIOverlay.css';
import TalksActionsUI from './ui/TalksActionsUI';
import TransformUI from './ui/TransformUI';
import ConfirmAlertUI from './ui/ConfirmAlertUI';
import { globals } from '../misc/globals';
import SbarUI from './ui/SbarUI';
import FullPageQuizUI from './ui/FullPageQuizUI';
import ProviderFeedbackUI from './ui/ProviderFeedbackUI';
import LoadedAssetsUI from '../cvp-webgames-core/Components/general/react/LoadedAssetsUI';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { Windows } from '../pages/MainPage';
import Tools from '../cvp-webgames-core/Misc/Tools';
import ReactCaption from '../cvp-webgames-core/Components/general/react/ReactCaption';
import { ClosedCaptionManager } from '../cvp-webgames-core/ClosedCaptionManager';
var showScoreForCurrentBadge = false;

const reducer = (state: any, action: any) => {
	return state;
};
var ccManager: ClosedCaptionManager = null;

//globals.showDebugForComponents = Tools.isLocalhost();

const UIOverlay = (props: any) => {
	const [uisRegistered, setUisRegistered] = useState(false);
    const [enableDebugMenu, setEnableDebugMenu] = useState(globals.showDebugForComponents);//window.location.hostname === 'localhost');
	const [state, dispatch] = useReducer(reducer, {
		uiProps: null,
		gameManager: props.gameManager
	});


    var isDisplayingHeader = false;

    (window as any).setCCManager = (ccM: any) => {
        ccManager = ccM;
        (window as any).forceUpdateInternalCCComp(); 
        // if((window as any).onCaptionsChanged) {
        //     (window as any).onCaptionsChanged();
        // }
    }

    
    const getScoreForCurrentScenario = () => {
        var savedData = props.gameManager.customData.saveData;
        var id = parseInt(props.scenarioId[props.scenarioId.length - 1]) - 1;
        var scenario = savedData.scenarios[id];

        var result: {
            key: string,
            current?: number,
            max: number
        }[] = [];

        for(var indx = 0; indx < scenario.badges.length; indx++) {
            result.push({
                key: scenario.badges[indx].key,
                max: scenario.badges[indx].maxPoints,
                current: (scenario as any).scores && (scenario as any).scores.length > indx ? (scenario as any).scores[indx] : 0
            })
        }

        return result;
    }


    const renderComponent = (instance: any, renderCallback: () => any) => {
        return (
            <div style={{
                display: instance.parameters.isVisible ? 'block' : 'none'
            }}>
                {renderCallback()}
            </div>
        )
    }

	useEffect(() => {
		$(window).resize();

		if(uisRegistered) {
			return;
		}

        var counter = 0;
		var interval = setInterval(() => {
			globals.queryMemory = true;
			counter++;
			if(counter >= 60) {
				clearInterval(interval);
			}
		}, 2000);

		setUisRegistered(true);

		var uiManager = props.gameManager.UiManager as JsxUIManager;

        uiManager.registerUI(constants.uiNames.HeaderUI, {
            renderMethod: (instance: any) => {
                isDisplayingHeader = true;
                return (
                    <div id={instance.id}>
                        <HeaderUI id={'header-container-ui-root'} dispatch={dispatch} key={instance.id} parameters={{...instance.parameters, updateWindow: props.updateWindow}}></HeaderUI>

                        <ReactCaption
                            currentCaption={ccManager.currentCaption}
                            isPaused={ccManager.isPaused}
                        ></ReactCaption>
                    </div>
                )
            },
        }, constants.uiTags.Hud);


        uiManager.registerUI(constants.uiNames.SplashScreenUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <SplashScreenUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SplashScreenUI>
                });
            }
        });

		uiManager.registerUI(constants.uiNames.BeginScenarioUI, {
			renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return (
                        <div id={instance.id}>
                            <ReactCaption
                                currentCaption={ccManager.currentCaption}
                                isPaused={ccManager.isPaused}
                            ></ReactCaption>
                            <BeginScenarioUI id={'begin-scenario-ui-container-ui-root'} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></BeginScenarioUI>
    
                            
                        </div>
                        )
                });
			}
		});

        uiManager.registerUI(constants.uiNames.FooterUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <FooterUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></FooterUI>
                });
			},
        }, constants.uiTags.Hud);

        uiManager.registerUI(constants.uiNames.FailUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <FailUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></FailUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.ModalPopUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <ModalPopUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ModalPopUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.RememberUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <RememberUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></RememberUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.PatientRecordUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <PatientRecordUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></PatientRecordUI>
                });
            }
        }, constants.uiTags.PrUi);

        uiManager.registerUI(constants.uiNames.TalksActionsUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <TalksActionsUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></TalksActionsUI>
                });
            }
        }, constants.uiTags.TaUi);

        uiManager.registerUI(constants.uiNames.TransformUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <TransformUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></TransformUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.BadgingProgressUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <BadgingProgressUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></BadgingProgressUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.ResumeUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <ResumeUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ResumeUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.ReturnToMainMenuUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <ReturnToMainMenuUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ReturnToMainMenuUI>
                });
            }
        });

		uiManager.registerUI(constants.uiNames.FeedbackUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <FeedbackUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></FeedbackUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.ConfirmAlertUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <ConfirmAlertUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ConfirmAlertUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.SbarUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <SbarUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></SbarUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.FullPageQuizUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <FullPageQuizUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></FullPageQuizUI>
                });
            }
        });

        uiManager.registerUI(constants.uiNames.ProviderFeedbackUI, {
            renderMethod: (instance: any) => {
                return renderComponent(instance, () => {
                    return <ProviderFeedbackUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></ProviderFeedbackUI>
                });
            }
        });

	}, [state]);
	return state.gameManager && state.gameManager.environment && state.gameManager.environment.isReady ? (
		<div className="in-game-overlay-container in-game-ui-container ui-container-root">
			{props.gameManager.UiManager.render()}
			{props.gameManager.SoundManager.render()}
            <InternalCaptionComp></InternalCaptionComp>
            {enableDebugMenu ? (
                <button tabIndex={-1} style={{
                    position: 'absolute',
                    bottom: '60px',
                    left: '10px',
                    color: 'white',
                    pointerEvents: 'all',
                    zIndex: 100
                }} onClick={() => {
                    globals.showDebugForComponents = !globals.showDebugForComponents;
                    props.forceUpdate();
                }}>
                    {(globals.showDebugForComponents ? 'Hide' : 'Show') + ' Debug Tools'}
                </button>
            ) : (null)}

            {globals.showDebugForComponents ? (
                <button tabIndex={-1} style={{
                    position: 'absolute',
                    top: '30px',
                    left: '50%',
                    transform: 'translate (-50%, 0)',
                    color: 'white',
                    pointerEvents: 'all',
                    zIndex: 100
                }} onClick={() => {    
                    showScoreForCurrentBadge = !showScoreForCurrentBadge;
                    props.forceUpdate();
                }}>
                    {(showScoreForCurrentBadge ? 'Hide ' : 'Show ') + 'Score For Current Badge'}
                </button>
            ) : (null)}

            {globals.showDebugForComponents && showScoreForCurrentBadge ? ( 
                <div style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '10px',
                        zIndex: 100
                }}>
                    {getScoreForCurrentScenario().map(score => {
                        return (<p className="title-font" style={{
                            color: 'white'
                        }}>{score.key + ': ' + score.current + '/' + score.max }</p>)
                    })}
                </div>) : (null)}


                {globals.showDebugForComponents ? (
                    <div tabIndex={-1} style={{
                        position: 'absolute',
                        bottom: '30px',
                        left: '20px',
                        pointerEvents: 'all',
                        zIndex: 1000
                    }}>
                        <LoadedAssetsUI memory={globals.memory} assets={VideoEnvironment.videoAssets}></LoadedAssetsUI>
                    </div>
                ) : (null)}

			<audio id='button-click' src="./assets/audio/Default_ButtonClick.mp3" playsInline={true} controls={false}></audio>
			<audio id='button-rollover' src="./assets/audio/Default_ButtonRollover.mp3" playsInline={true} controls={false}></audio>

		</div>
	) : (null);
};

export default UIOverlay;

const InternalCaptionComp = () => {
    const [forceUpdate, setForceUpdate] = useState(false);

    (window as any).forceUpdateInternalCCComp = () => {
        setForceUpdate(!forceUpdate);
    }

    return (
        <div>
            {ccManager && ccManager.currentCaption && !ccManager.isPaused && <div className="caption-container">
                    {(window as any).CCEnabled &&
                        <div className="caption-block">
                            <p tabIndex={0} className="caption-paragraph" dangerouslySetInnerHTML={{__html: ccManager.currentCaption}}>
                            </p>
                        </div>
                    }
                </div>
                }

        </div>
    );

};